// Trade-secret fabrics on documents for the supplier (Preview / print of a PO or a Tech Pack).
import { navigate, onChange } from "./state.js";

/** The "Include full composition for trade-secret fabrics" tick box (Preview / print of a PO or Tech Pack): only offered to
 *  people allowed to see composition, and only when a trade-secret fabric is on the document. Ticking reloads the page. */
export function fullCompositionTick(d: any): string {
  if (!d.hasSecretComposition) return "";
  return `<label class="check-row" title="Off: trade-secret fabrics show their label wording. On: the full composition, and every page says &quot;Contains confidential composition&quot; (recorded in the Activity Log)."><input type="checkbox" data-change="doc-full-comp" ${d.fullComposition ? "checked" : ""}><span>Include full composition for trade-secret fabrics</span></label>`;
}
onChange("doc-full-comp", (el) => {
  const u = new URL(location.href);
  if ((el as HTMLInputElement).checked) u.searchParams.set("full", "1"); else u.searchParams.delete("full");
  void navigate(`${u.pathname}${u.search}`, true);
});
